export default __webpack_public_path__ + "4ae5f80c1647f19d466d7595a625538e.svg";